export default __webpack_public_path__ + "static/media/celuba-1.3a1b0d6e.jpg";